import { postUpdateWager } from '../api/postUpdateWager';
import {setGetUserById} from './setGetUserById';

const setPostUpdateWager = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateWager(params);
            dispatch(setGetUserById(params.id));
            window.location.replace(window.location.pathname);
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateWager
}